import {IWuAppHeaderMenuItem} from '@/components/appHeader/types/WuAppHeaderMenuItem'
import {cn} from '@/lib/utils'
import React, {RefObject, useEffect, useState} from 'react'
import {CategoryDetails} from './_categoryDetails'
import {ProductList} from './_productList'

interface IDropdownMenuProps {
  dropdownRef: RefObject<HTMLUListElement | null>
  dir: 'ltr' | 'rtl'
  isDropdownOpen: boolean
  productCategories: IWuAppHeaderMenuItem[]
  openCategory: IWuAppHeaderMenuItem | null
  setOpenCategory: React.Dispatch<
    React.SetStateAction<IWuAppHeaderMenuItem | null>
  >
  handleKeyDown: (e: React.KeyboardEvent<HTMLLIElement>, index: number) => void
  expandAll?: boolean
  activeProductName: string
  focusItem: string
  setFocusItem: (item: string) => void
}

export const ProductDropdownMenu: React.FC<IDropdownMenuProps> = ({
  dropdownRef,
  dir,
  isDropdownOpen,
  productCategories,
  openCategory,
  setOpenCategory,
  handleKeyDown,
  expandAll,
  activeProductName,
  focusItem,
  setFocusItem,
}) => {
  const borderColorLocked = '#ffcf70'

  const [isHoverMode, setHoverMode] = useState(window.innerWidth > 768)

  useEffect(() => {
    const handleResize = (): void => {
      setHoverMode(window.innerWidth > 375)
    }
    window.addEventListener('resize', handleResize)
    return (): void => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <ul
      className={cn(
        'productDropdownMenu',
        isDropdownOpen && 'productDropdownMenuOpen',
        dir === 'rtl' && 'rtlDropdownMenu',
        'wu-switcher-container',
      )}
      ref={dropdownRef}
      dir={dir}
      aria-label="product-dropdown-menu"
    >
      {productCategories.map((category, index) => {
        return (
          <li
            key={category.name}
            className={cn(
              'productCategory focus:outline-none focus-visible:outline-none h-16 wu-category-item',
              openCategory === category && 'open',
              expandAll && 'open',
            )}
            onMouseEnter={() => isHoverMode && setOpenCategory(category)}
            onMouseLeave={() => isHoverMode && setOpenCategory(null)}
            aria-label={category.name}
            dir={dir}
            onKeyDown={e => handleKeyDown(e, index)}
            tabIndex={0}
          >
            <CategoryDetails
              category={category}
              dir={dir}
              openCategory={openCategory}
            />
            <ul
              className={cn('productList', dir === 'rtl' && 'rtlProductList')}
              dir={dir}
            >
              <ProductList
                category={category}
                dir={dir}
                activeProductName={activeProductName}
                currentProduct={category.name}
                focusItem={focusItem}
                setFocusItem={setFocusItem}
                borderColorLocked={borderColorLocked}
              />
            </ul>
          </li>
        )
      })}
    </ul>
  )
}
